// import components and types
import {
  styled,
  Box,
  TableCell,
  TableRow,
  Table,
  TableProps,
  TableCellProps,
  TableRowProps,
  BoxProps,
  Typography
} from '@mui/material';

// import styles
import { IconContainer } from 'components/mrp/mrp.styles';

export const StyledSummaryCardTableCellBox = styled(Box)<BoxProps>(() => ({
  height: '100%',
  display: 'flex'
}));

export const StyledSummaryCardTable = styled(Table)<TableProps>(() => ({
  'tr:last-child td': { border: 0 },
  th: { fontFamily: 'SourceSansPro-Regular' },
  'tr td:first-of-type': { fontFamily: 'SourceSansPro-Bold' }
}));

export const StyledSummaryCardTableCell = styled(TableCell)<TableCellProps>(
  () => ({
    border: 'none'
  })
);

export const StyledSummaryCardListTableCell = styled(
  StyledSummaryCardTableCell
)(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const StyledSummaryCardTableRow = styled(TableRow)<TableRowProps>(
  ({ theme }) => ({
    verticalAlign: 'top',
    borderBottom: '1px solid ' + theme.palette.divider,

    '&:last-child': {
      borderBottom: 'none'
    }
  })
);

export const StyledSummaryCardIconContainer = styled(IconContainer)(
  ({ theme }) => ({
    marginRight: theme.spacing(4)
  })
);

export const StyledLinkIcon = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  marginLeft: theme.spacing(0.5),
  cursor: 'pointer',
  '& svg': {
    fontSize: theme.typography.pxToRem(12)
  }
}));

export const StyledSummaryCardLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 12,
  textTransform: 'lowercase',
  '&:first-letter': {
    textTransform: 'uppercase'
  },
  borderBottom: `1px dashed ${theme.vars.palette.outline.variant}`
}));
